<template>
	<section id="contacto" class="azulMuyClaro mt-15">
		<v-container id="container" class="py-15">
			<v-row class="mb-15">
				<v-col cols="12" md="6" align-self="center" class="my-15">
					<v-row justify="center">
						<v-container class="neftysGradientHard pa-15" fluid>
              <v-col v-scrollanimation cols="12" md="12" class="anim mb-8">
                <a>
                  <v-img
                      class="w-100"
                      max-width="120"
                      src="@/assets/img/logo-neftys-white.svg"
                      contain
                  />
                </a>
              </v-col>
							<v-col v-scrollanimation cols="12" class="anim">
                <v-row>
                  <v-col md="6">
                    <v-img class="contactIcon" contain>
                      <svg
                          id="Icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                      >
                        <rect id="Area" width="20" height="20" fill="#FFBA3F" opacity="0" />
                        <g id="Icon-2" data-name="Icon" transform="translate(1.29 2.499)">
                          <path
                              id="Path"
                              d="M3.333,3.333H16.667A1.671,1.671,0,0,1,18.333,5V15a1.671,1.671,0,0,1-1.666,1.667H3.333A1.671,1.671,0,0,1,1.667,15V5A1.671,1.671,0,0,1,3.333,3.333Z"
                              transform="translate(-1.29 -2.499)"
                              fill="none"
                              stroke="#FFF"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                          />
                          <path
                              id="Path-2"
                              data-name="Path"
                              d="M18.333,5,10,10.833,1.667,5"
                              transform="translate(-1.29 -2.499)"
                              fill="none"
                              stroke="#FFF"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                          />
                        </g>
                      </svg>
                    </v-img>
                    <p class="white--text contactText">{{ $t('info.contacto') }}: <br/><a href="mailto:ventas.sd@neftysfarma.es"><p class="white--text">ventas.sd@neftysfarma.es</p></a></p>
                  </v-col>
                  <v-col md="6">
                    <v-img class="contactIcon" contain>
                      <svg
                          id="Icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                      >
                        <rect id="Area" width="20" height="20" fill="#FFF" opacity="0" />
                        <g id="Icon-2" data-name="Icon" transform="translate(1.29 2.499)">
                          <path
                              id="Path"
                              d="M18.333,14.1v2.5a1.667,1.667,0,0,1-1.816,1.667,16.488,16.488,0,0,1-7.192-2.559,16.24,16.24,0,0,1-5-5A16.488,16.488,0,0,1,1.767,3.483,1.667,1.667,0,0,1,3.425,1.667h2.5A1.666,1.666,0,0,1,7.592,3.1a10.68,10.68,0,0,0,.583,2.342A1.665,1.665,0,0,1,7.8,7.2L6.742,8.258a13.319,13.319,0,0,0,5,5L12.8,12.2a1.665,1.665,0,0,1,1.758-.375,10.68,10.68,0,0,0,2.342.583A1.667,1.667,0,0,1,18.333,14.1Z"
                              transform="translate(-1.29 -2.499)"
                              fill="none"
                              stroke="#FFF"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                          />
                        </g>
                      </svg>
                    </v-img>
                    <p class="white--text contactText">
                      {{ $t('info.dias') }}<br />
                      {{ $t('info.horas') }}<br />
                      {{ $t('info.numTelefono') }}
                    </p>
                  </v-col>
                  <v-col md="6">
                    <v-img class="contactIcon" contain>
                      <svg
                          id="Icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                      >
                        <rect id="Area" width="20" height="20" fill="#FFF" opacity="0" />
                        <g id="Icon-2" data-name="Icon" transform="translate(1.29 2.499)">
                          <path
                              id="Path"
                              d="M17.5,8.333c0,5.834-7.5,10.834-7.5,10.834s-7.5-5-7.5-10.834a7.5,7.5,0,1,1,15,0Z"
                              transform="translate(-1.29 -2.499)"
                              fill="none"
                              stroke="#FFF"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                          />
                          <circle
                              id="Path-2"
                              data-name="Path"
                              cx="2.5"
                              cy="2.5"
                              r="2.5"
                              transform="translate(6.21 3.334)"
                              fill="none"
                              stroke="#FFF"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                          />
                        </g>
                      </svg>
                    </v-img>
                    <p class="white--text contactText">
                      <span class="font-20">{{ $t('nav.delegacion1') }}</span><br />&nbsp;<br />
                      Carrer dels Fusters, 3 - {{ $t('info.poligono') }} H6 ({{ $t('info.autovia') }} de Bellisens)<br />&nbsp;<br />
                      43204 Reus (Tarragona)
                    </p>
                  </v-col>
                  <v-col md="6">
                    <v-img class="contactIcon" contain>
                      <svg
                          id="Icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                      >
                        <rect id="Area" width="20" height="20" fill="#FFF" opacity="0" />
                        <g id="Icon-2" data-name="Icon" transform="translate(1.29 2.499)">
                          <path
                              id="Path"
                              d="M17.5,8.333c0,5.834-7.5,10.834-7.5,10.834s-7.5-5-7.5-10.834a7.5,7.5,0,1,1,15,0Z"
                              transform="translate(-1.29 -2.499)"
                              fill="none"
                              stroke="#FFF"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                          />
                          <circle
                              id="Path-2"
                              data-name="Path"
                              cx="2.5"
                              cy="2.5"
                              r="2.5"
                              transform="translate(6.21 3.334)"
                              fill="none"
                              stroke="#FFF"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="1.667"
                          />
                        </g>
                      </svg>
                    </v-img>
                    <p class="white--text contactText">
                      <span class="font-20">{{ $t('nav.delegacion2') }}</span><br />&nbsp;<br />
                      Carrer Torelló, 17-19<br />&nbsp;<br />
                      08500 Vic (Barcelona)
                    </p>
                  </v-col>
                </v-row>
							</v-col>
						</v-container>
					</v-row>
				</v-col>
				<v-col cols="12" md="6">
					<v-container class="fill-height">
						<v-row justify="center" class="mb-5 my-md-15">
							<v-col cols="11" md="8" class="py-0">
								<h2 class="font-weight-bold mb-4 primary--text">
									{{ $t('contacto.titulo') }}
								</h2>
								<p class="font-weight-light mt-4 primary--text">
									{{ $t('contacto.texto') }}
								</p>

								<!-- <v-row justify="center">
                 <v-icon color="secondary">mdi-email
                  </v-icon>  
                 <h1 class="text-center secondary--text pl-3">
                   info@ebersy.com
                 </h1>
               </v-row>   -->
							</v-col>
							<v-col cols="11" md="8" class="py-0">
								<v-form ref="form" v-model="valid" lazy-validation>
									<v-text-field
										v-model="name"
										:rules="nameRules"
										:label="$t('contacto.nombre')"
										required
										name="nombre"
									></v-text-field>

									<v-text-field
										v-model="email"
										:rules="emailRules"
										label="E-mail"
										required
										name="email"
									></v-text-field>

									<!-- <v-select
                  v-model="select"
                  :items="items"
                  :rules="[(v) => !!v || 'Item is required']"
                  label="Item"
                  required
                  ></v-select> -->

									<v-textarea
										v-model="textarea"
										:rules="textareaRules"
										outlined
										clearable
										dense
										background-color="white"
										name="textarea"
										:label="$t('contacto.mensaje')"
										rows="3"
										auto-grow
									>
									</v-textarea>

									<div class="d-flex align-center flex-wrap">
										<v-checkbox v-model="checkbox" :rules="[(v) => !!v]" color="accent"></v-checkbox>
										<p class="pt-4 text-caption">
											{{ $t('contacto.acepto') }}
											<router-link class="accent--text text-decoration-none" to="Legal"
												><span @click="$vuetify.goTo(0)">{{ $t('info.aviso') }}</span>
											</router-link>
											y
											<router-link class="accent--text text-decoration-none" to="Politica"
												><span @click="$vuetify.goTo(0)">{{ $t('info.privacidad') }}</span>
											</router-link>
										</p>
									</div>

									<v-btn @click="enviarEmail" :disabled="!checkValidations" block class="accent">{{
										$t('contacto.enviar')
									}}</v-btn>
								</v-form>
							</v-col>
						</v-row>
					</v-container>
				</v-col>

				<!-- <v-container fluid>
          <p class="text-center">
            {{ $t("contacto.solicitudtext") }}
          </p>
          <div class="d-flex justify-center">
            <v-btn
              dark
              class="amarillo mt-10"
              href="solicitud.pdf"
              type="application/pdf"
              rel="alternate"
              media="print"
              target="_blank"
            >
              <v-icon class="pr-2">mdi-download</v-icon>
              {{ $t("contacto.solicitud") }}</v-btn
            >
          </div>
        </v-container> -->
			</v-row>
		</v-container>
		<div class="mapa">
			<iframe
				src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3005.5956718727202!2d1.1550748154175532!3d41.1215206792895!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12a15766ff362dcb%3A0xb63473da5a6f8901!2sSol%C3%A0%20Domingo%20S.A.!5e0!3m2!1ses!2ses!4v1671638681768!5m2!1ses!2ses"
				width="100%"
				height="450"
				style="border: 0"
				allowfullscreen=""
				loading="lazy"
			></iframe>
		</div>
	</section>
</template>

<script>
export default {
	data: () => ({
		valid: false,
		name: '',
		nameRules: [(v) => !!v],
		email: '',
		emailRules: [(v) => !!v, (v) => /.+@.+\..+/.test(v)],
		select: null,
		textarea: '',
		textareaRules: [(v) => !!v],
		checkbox: false,
	}),
	methods: {
		enviarEmail() {
			window.open(`mailto:ventas.sd@neftysfarma.es?subject=${this.name}&body=${this.email} ${this.textarea}`);

			/* if (this.$refs.form.validate()) {
        
        const response = await mailchimpClient.messages.send({ message: {
          from_email: this.email,
          to: [
            {
              email: 'ventas.sd@neftysfarma.es',
              type: 'to',
            }
          ],
          subject: 'Contacto Web Sola Domingo',
          html: `
            <h3>${ this.name }</h3>
            <p>${ this.textarea }</p>
          `
        } });

        console.log(response);
      } */
		},
	},

	computed: {
		checkValidations() {
			return this.valid && this.checkbox && true;
		},
	},
};
</script>

<style scoped>
#contacto {
	min-height: 100vh;
}
* {
	text-decoration: none !important;
}

.neftysGradientHard {
  background: rgb(44,86,159);
  background: linear-gradient(131deg, #2c569f 50%, #099247 100%);
}

.contactIcon {
  float: left;
}

.contactText {
  padding-left: 2em;
}

.font-20 {
  font-size: 20px;
  font-weight: bold;
}

</style>
